import { Table } from "@tiptap/extension-table";
import { ReactNodeViewRenderer } from "@tiptap/react";
import TableBlockComponent from "../nodeviews/TableBlockComponent";

const TableBlock = Table.extend({
    addNodeView() {
        return ReactNodeViewRenderer(TableBlockComponent);
    },
});

export default TableBlock;
